<script lang="ts">
    import { _ } from 'svelte-i18n';

    export let items: { id: string; label: string }[] = [];
    export let selected: string = '';
    export let onChange: (selected: string) => boolean = () => true;
    export let disabled: boolean = false;
    export let width: string = '';
    export let withBorder: boolean = false;
    export let styleMode: 'bordered' | 'non-bordered' | 'underline' = 'bordered';
    /** labels are locale keys by default; set to false for text that is already translated or dynamic */
    export let translateLabels: boolean = true;

    styleMode = styleMode ? styleMode : withBorder ? 'bordered' : 'non-bordered';
    export let useDefaultStyles: boolean = true;

    // onChange(selected);

    $: {
        selected = selected;
        console.log('Select', selected);
    }
</script>

<select
    on:click={() => {
        console.log('Select clicked');
    }}
    bind:value={selected}
    class="input-small-transparent {useDefaultStyles ? 'input-small-default' : ''} {withBorder
        ? 'withBorder'
        : ''} {styleMode}"
    style={width !== '' ? `width:${width}` : ''}
    class:disabled
    {disabled}
    on:change={e => {
        console.log('Select', e.target?.value, 'changed');
        if (disabled) return;
        selected = (e.target && e.target?.value) || '';
        if (typeof onChange === 'function') {
            let success = onChange(selected);
            if (!success) {
                console.log('Select', selected, 'failed, reverting');
                selected = '';
            }
        } else {
            console.warn('onChange is not a function, reverting select to previous value');
        }
    }}
>
    {#each items as item}
        <option value={item.id} selected={selected === item.id}>
            {translateLabels ? $_(item.label) : item.label}
        </option>
    {/each}
</select>

<style>
    .input-small-transparent {
        border: none;
        border-radius: var(--input-small-border-radius);
        background-color: transparent;
        cursor: pointer;
    }
    .input-small-default {
        padding: var(--input-small-padding);
        border: var(--input-small-border);
        border-radius: var(--input-small-border-radius);
        color: var(--input-small-color);
        background-color: #fff;
        cursor: pointer;
    }
    .withBorder {
        border: 1px solid #ccc;
    }
    .underline {
        border-bottom: 1px solid #333;
        width: 75px !important;
        text-align: center;
        border-radius: 0;
        color: #333;
        padding: 2px 0 !important;
        font-weight: 600;
    }
    .disabled {
        background-color: #f7f7f7;
    }
</style>
